
import {
  Category,
  Content,
  NodeItem,
} from "@/script/apps/cms/entity/CmsEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { MenuData } from "@/script/core/base/MenuData";
import bus from "@/script/core/util/Bus";
import { CallBack } from "@/script/core/service/DataService";

@Options({})
export default class ContentRefer extends BaseList {
  private categoryList: Category[] | null = null;

  private treeData: NodeItem[] = [];

  private expandedKeys: number[] = [1];

  private selectedId: number | null = null;

  private categoryIds = "";

  private dialogVisible = false;

  private callBack: CallBack<Content> | null = null;

  private currentRow: Content | null = null;

  defaultProps = {
    children: "children",
    label: "label",
  };

  private queryEntity: Content = {};

  private dataList: Content[] = [];

  private service = new ContentService();

  activated() {
    const categoryService = new CategoryService();
    categoryService.loadParentCategorys(0, (data: any) => {
      this.categoryList = data as Category[];

      const parentNodes: NodeItem[] = [];
      this.categoryList.forEach((item) => {
        if (item.parentId == null) {
          const parentNode: NodeItem = new NodeItem();
          parentNode.id = Number(item.id);
          parentNode.label = String(item.name);
          this.getChilds(this.categoryList!, parentNode);
          parentNodes.push(parentNode);
        }
      });
      this.treeData = parentNodes;
    });
  }

  public initData(): ServiceContext {
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      sorters: [
        { prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" },
        { prop: "id", sortField: "cc.id", sortMode: "desc" },
      ],
    };
    return ServiceFactory.build(
      "biz_cms_content",
      "/cms/content",
      "/cms/content",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      title: "",
    };
    return this.queryEntity;
  }

  private getChilds(dataList: Category[], node: NodeItem) {
    const childNodes: NodeItem[] = [];
    dataList.forEach((item) => {
      if (item.parentId === node.id) {
        const childNode: NodeItem = new NodeItem();
        childNode.id = Number(item.id);
        childNode.label = String(item.name);
        childNodes.push(childNode);

        this.getChilds(dataList, childNode);
      }
    });
    node.children = childNodes;
  }

  private getChildIds(dataList: Category[], node: NodeItem, ids: number[]) {
    dataList.forEach((item) => {
      if (item.parentId === node.id) {
        const childNode: NodeItem = new NodeItem();
        ids.push(item.id!);
        this.getChildIds(dataList, childNode, ids);
      }
    });
  }

  public afterLoadList(data: any): void {
    const currDataList: Content[] = data.list as Content[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  handleNodeClick(data: any) {
    this.selectedId = data.id;
    this.queryParam.extendMap = {};
    const ids: number[] = [data.id];
    this.getChildIds(this.categoryList!, data, ids);
    this.queryParam.extendMap.categoryIds = ids.join(",");
    this.categoryIds = this.queryParam.extendMap.categoryIds;
    this.loadList();
  }

  changeCurrentRow(row: Category) {
    this.currentRow = row;
  }

  public show(callBack: CallBack<Category>) {
    this.currentRow = null;
    this.callBack = callBack;
    this.dialogVisible = true;
  }

  private opened() {
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  confirm() {
    if (this.currentRow === null) {
      ElMessage.error("请选择文章！");
      return;
    }
    this.dialogVisible = false;
    if (this.callBack) {
      this.callBack(this.currentRow!);
    }
  }
}
